import { supabase } from "@supabaseClient/supabaseClient";
import type { Subscription } from "../types";

export const billingClient = {
  /** The org's subscription row, or null if billing has never been started. */
  getSubscription: async (orgId: string): Promise<Subscription | null> => {
    const { data } = await supabase
      .from("subscriptions")
      .select("*")
      .eq("organization_id", orgId)
      .maybeSingle()
      .throwOnError();
    return (data as Subscription | null) ?? null;
  },

  /** Returns a Stripe Checkout URL to redirect the user to. */
  createCheckoutSession: async (): Promise<string> => {
    const { data, error } = await supabase.functions.invoke<{ url: string }>(
      "create-checkout-session",
      { body: {} },
    );
    if (error) throw error;
    if (!data?.url) throw new Error("No checkout URL returned");
    return data.url;
  },

  /** Returns a Stripe Customer Portal URL to redirect the user to. */
  createPortalSession: async (): Promise<string> => {
    const { data, error } = await supabase.functions.invoke<{ url: string }>(
      "create-portal-session",
      { body: {} },
    );
    if (error) throw error;
    if (!data?.url) throw new Error("No portal URL returned");
    return data.url;
  },
};
